"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalForm = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const FormFields_1 = require("@reactionable/core/lib/form/FormFields");
const I18n_1 = require("@reactionable/core/lib/i18n/I18n");
const ModalForm_1 = require("@reactionable/core/lib/ui/modal/ModalForm");
const Modal_1 = tslib_1.__importDefault(require("react-bootstrap/Modal"));
const FormButton_1 = require("../form/FormButton");
function ModalFormChildren({ cancelButton, submitButton, children, closeModal, formikProps, }) {
    const { t } = I18n_1.useTranslation();
    const submit = FormButton_1.useSubmitFormButton({
        children: submitButton !== null && submitButton !== void 0 ? submitButton : true,
        disabled: formikProps.isSubmitting,
    });
    const cancel = FormButton_1.useFormButton({
        children: cancelButton || t("Cancel"),
        disabled: formikProps.isSubmitting,
        onClick: closeModal,
        variant: "secondary",
    });
    return (jsx_runtime_1.jsxs(jsx_runtime_1.Fragment, { children: [jsx_runtime_1.jsx(Modal_1.default.Body, { children: jsx_runtime_1.jsx(FormFields_1.FormFields, Object.assign({ formikProps: formikProps }, { children: children }), void 0) }, void 0),
            jsx_runtime_1.jsxs(Modal_1.default.Footer, { children: [cancel, submitButton !== false && submit] }, void 0)] }, void 0));
}
function ModalForm(_a) {
    var { children, submitButton, cancelButton } = _a, props = tslib_1.__rest(_a, ["children", "submitButton", "cancelButton"]);
    const formChildren = (formikProps) => (jsx_runtime_1.jsx(ModalFormChildren, Object.assign({ cancelButton: cancelButton, submitButton: submitButton, closeModal: props.closeModal, formikProps: formikProps }, { children: children }), void 0));
    return (jsx_runtime_1.jsx(ModalForm_1.ModalForm, Object.assign({}, props, { submitButton: false }, { children: formChildren }), void 0));
}
exports.ModalForm = ModalForm;
//# sourceMappingURL=ModalForm.js.map